import { useTranslation } from "react-i18next";
import {
  deepCopy,
  isEmptyList,
  isNullOrUndefined,
  logAnalyticsEvent,
  sortByField,
} from "../../utils";
// import { useMainContext } from "../../MainContext";
import TurnarounDocsItem from "./TurnaroundModuleDocsItem";
import TurnaroundModuleDocsModal from "./TurnaroundModuleDocsModal";
import { useState } from "react";
import ImageAssetModal from "../ImageAsset/ImageAssetModal";
import { ANALYTICS_EVENTS } from "../../constants";
import { useMainDispatchContext } from "../../MainContext";

function TurnaroundModuleDocs(props) {
  const { operation, timezone, turnaroundUuid, isReadonly } = props;
  const { t } = useTranslation();
  const dispatch = useMainDispatchContext();
  const [itemToEdit, setItemToEdit] = useState(null);
  const [imageAssetToShow, setImageAssetToShow] = useState(null);

  const eventsToRender = !isEmptyList(operation?.events)
    ? deepCopy(operation?.events)
    : null;
  if (!isEmptyList(eventsToRender)) {
    sortByField(eventsToRender, "name");
  }
  return (
    <div className="turnaround-module-docs">
      <div>
        {isEmptyList(eventsToRender) && (
          <div className="empty-state">{t("no_results")}</div>
        )}
        {!isEmptyList(eventsToRender) &&
          eventsToRender.map((i) => (
            <TurnarounDocsItem
              key={i.uuid}
              item={i}
              timezone={timezone}
              onEdit={() => {
                setItemToEdit(i);
                logAnalyticsEvent(
                  dispatch,
                  ANALYTICS_EVENTS.TURNAROUNDS_DETAILS_VIEW_OPERATION_EVENT
                );
              }}
              onShowImage={() => {
                setImageAssetToShow(i.image);
                logAnalyticsEvent(
                  dispatch,
                  ANALYTICS_EVENTS.TURNAROUNDS_DETAILS_VIEW_OPERATION_EVENT_IMAGE
                );
              }}
              isReadonly={isReadonly}
            />
          ))}
      </div>
      {!isNullOrUndefined(itemToEdit) && (
        <TurnaroundModuleDocsModal
          onClose={() => {
            setItemToEdit(null);
          }}
          onSave={() => {
            setItemToEdit(null);
          }}
          timezone={timezone}
          item={itemToEdit}
          turnaroundUuid={turnaroundUuid}
        />
      )}
      {!isNullOrUndefined(imageAssetToShow) && (
        <ImageAssetModal
          imageAsset={imageAssetToShow}
          onClose={() => {
            setImageAssetToShow(null);
          }}
        />
      )}
    </div>
  );
}

export default TurnaroundModuleDocs;
